// data/languages/peul/categories/corps.ts

import { CategoryData } from '../../../../types/types';

export const corps: CategoryData = {
  // TÊTE ET VISAGE - Vérifiés selon sources académiques
    'Banndu': { translation: 'Corps', translationEn: 'Body', illustration: '', audio: 'Ff-Banndu' },
    'Hito': { translation: 'Voix', translationEn: 'Voice', illustration: '', audio: 'Ff-Hito' },
   'Miijo': { translation: 'Pensée', translationEn: 'Thought', illustration: '', audio: 'Ff-Miijo' },
  'Hakkile': { translation: 'Esprit', translationEn: 'Mind', illustration: '', audio: 'Ff-Hakkile' },
  'Hoore': { translation: 'Tête', translationEn: 'Head', illustration: '🧠', audio: 'Ff-Hoore' },
  'Yeeso': { translation: 'Visage', translationEn: 'Face', illustration: '😊' },
  'Yitere': { translation: 'Œil', translationEn: 'Eye', illustration: '👁️', audio: 'Ff-Yitere' },
  'Guite': { translation: 'Yeux', translationEn: 'Eyes', illustration: '👁️', audio: 'Ff-Guite' },
  'Kinal': { translation: 'Nez', translationEn: 'Nose', illustration: '👃', audio: 'Ff-Kinal' },
  'Boude kine': { translation: 'Les narines', translationEn: 'The nostrils', illustration: '👃', audio: 'Ff-Boude_kine' },
  'Hunduko': { translation: 'Bouche', translationEn: 'Mouth', illustration: '👄' },
  'Noppi': { translation: 'Oreille', translationEn: 'Ear', illustration: '👂', audio: 'Ff-Noppi' },
  'Gniidje': { translation: 'Dent', translationEn: 'Tooth', illustration: '🦷', audio: 'Ff-Gniidje' },
  'Ndingal': { translation: 'Langue', translationEn: 'Tongue', illustration: '👅', audio: 'Ff-Ndingal' },
  'Ton-ndou': { translation: 'Lèvres', translationEn: 'Lips', illustration: '💋', audio: 'Ff-Ton-ndou' },
  'Soukoundou': { translation: 'Cheveux', translationEn: 'Hair', illustration: '💇', audio: 'Ff-Soukoundou' }, // Terme correct pour cheveux
    'Daande': { translation: 'Gorge', translationEn: 'Throat', illustration: '🫱', audio: 'Ff-Daande' },
    'Bandou': { translation: 'Peau', translationEn: 'Skin', illustration: '🫱', audio: 'Ff-Bandou' },
   'Collis': { translation: 'Doigts', translationEn: 'Fingers', illustration: '🫱', audio: 'Ff-Collis' },
  'Newre': { translation: 'La paume', translationEn: 'The palm', illustration: '🫱', audio: 'Ff-Newre' },
   'Doole': { translation: 'Les muscles', translationEn: 'The muscles', illustration: '', audio: 'Ff-Doole' },
  'Indi': { translation: 'Les seins', translationEn: 'The breasts', illustration: '', audio: 'Ff-Indi' },
    'Indou': { translation: 'Le sein', translationEn: 'The breast', illustration: '', audio: 'Ff-Indou' },
    'Bobi': { translation: 'Les fesses', translationEn: 'The buttocks', illustration: '' },
  'Howrou': { translation: 'Le genou', translationEn: 'The knee', illustration: '', audio: 'Ff-Howrou' },

  // MEMBRES - Avec précisions anatomiques
  'Junngo': { translation: 'Bras', translationEn: 'Arm', illustration: '💪' }, // Précisé : bras seulement
  'Junni': { translation: 'Main', translationEn: 'Hand', illustration: '🤚' }, // Séparé main de bras
  'Koyngal': { translation: 'Jambe', translationEn: 'Leg', illustration: '🦵' }, // Précisé : jambe seulement
  'Coydhe': { translation: 'Les pieds', translationEn: 'The feet', illustration: '🦶🦶', audio: 'Ff-Coydhe' }, // Séparé pied de jambe
   'Coyngal': { translation: 'Un pied', translationEn: 'A foot', illustration: '🦶' }, // Séparé pied de jambe
   'Ley nooki': { translation: 'Les aisselles', translationEn: 'The armpits', illustration: '', audio: 'Ff-Ley_nooki' }, // Séparé pied de jambe
  'Hondu': { translation: 'Doigt', translationEn: 'Finger', illustration: '👆' },
  'Ɓerndu': { translation: 'Orteil', translationEn: 'Toe', illustration: '🦶' }, // Corrigé de Poddu
  'Pédaali': { translation: 'Ongle', translationEn: 'Nail', illustration: '💅', audio: 'Ff-Pedaali' },
  'Ɓalɓe': { translation: 'Épaule', translationEn: 'Shoulder', illustration: '🫱' },
  'Leebi': { translation: 'Les poils', translationEn: 'The body hair', illustration: '', audio: 'Ff-Leebi' },
  'Leebol': { translation: 'Un poil', translationEn: 'A single hair', illustration: '', audio: 'Ff-Leebol' },


  // TRONC ET ORGANES INTERNES
  'Ɓhernde': { translation: 'Cœur', translationEn: 'Heart', illustration: '❤️', audio: 'Ff-Bhernde' },
  'Reedou': { translation: 'Ventre/Estomac', translationEn: 'Belly/Stomach', illustration: '🫃', audio: 'Ff-Reedou' },
  'Ɓaawo': { translation: 'Dos', translationEn: 'Back', illustration: '🫸', audio: 'Ff-Baawo' }, // Corrigé orthographe
  'Heyre': { translation: 'Foie', translationEn: 'Liver', illustration: '🫀' },
  'Djiyal': { translation: 'Os', translationEn: 'Bone', illustration: '🦴', audio: 'Ff-Djiyal' }, // Ajouté terme important
    'Djiye': { translation: 'Les os', translationEn: 'The bones', illustration: '🦴', audio: 'Ff-Djiye' }, // Ajouté terme important


  // AJOUTS IMPORTANTS - Termes manquants essentiels
  'Woore': { translation: 'Cou', translationEn: 'Neck', illustration: '🫱' },
  'Fuɗɗe': { translation: 'Poitrine', translationEn: 'Chest', illustration: '🫁' },

  'Ɓulnde': { translation: 'Genou', translationEn: 'Knee', illustration: '🦵' },
  'Kuurgal': { translation: 'Talon', translationEn: 'Heel', illustration: '🦶' }
};

export default corps;

export {};
